
import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';

export const useCredentialValidate = (credentailName:string) => {
    return useQuery<any, Error>(
        ['CredValidate'],
        async () => {
            const jsonResponse = await request({
                endpoint: 'credentials/validate-contact-credential',
                data: {
                    credentialName:credentailName
                },
                
            });

            if (!jsonResponse.success) {
                throw new Error(jsonResponse.data.Message || 'Something went wrong');
            }

            return jsonResponse;
        },
      {
    refetchOnWindowFocus: false,  

      }
    );
};
